import { Asset } from '../..';
import { clubsLoadedState } from '../../../../../../../../store/product/atom';
import {
  clubsCustomFiltersQuery,
  clubsQueryUpdated,
} from '../../../../../../../../store/product/selectors';

import { ClubsItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const ClubsAsset = () => {
  return (
    <Asset
      productsQuery={clubsQueryUpdated}
      customFiltersQuery={clubsCustomFiltersQuery}
      ProductItem={ClubsItem}
      ProductItemLoading={ListLoadingItem}
      atomToSetProductsLoaded={clubsLoadedState}
      keySelector="clubId"
    />
  );
};
